import { render, staticRenderFns } from "./ConnectorCardNew.vue?vue&type=template&id=72a96a7a&scoped=true"
import script from "./ConnectorCardNew.vue?vue&type=script&lang=js"
export * from "./ConnectorCardNew.vue?vue&type=script&lang=js"
import style0 from "./ConnectorCardNew.vue?vue&type=style&index=0&id=72a96a7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a96a7a",
  null
  
)

export default component.exports